import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowDown02Icon,
  ArrowUp02Icon
} from "@hugeicons-pro/core-solid-rounded";

import { cx } from "shared/utils";

import { Show } from "shared/components";
import { SortDirection } from "react-data-grid";

type HeaderWithSortProps = {
  label?: string;
  columnKey: string;
  onSort: (columnKey: string) => void;
  sortDirection?: SortDirection;
};

export const HeaderWithSort = ({
  label,
  columnKey,
  onSort,
  sortDirection
}: HeaderWithSortProps) => {
  const isDueDate = columnKey === "dueLabel";
  const defaultDirection = "ASC";
  const currentDirection = sortDirection ?? defaultDirection;

  return (
    <div className="flex justify-start items-center gap-1 cursor-pointer">
      <Show if={Boolean(label)}>
        <span className="text-xs font-medium text-content-300">{label}</span>
      </Show>
      <button onClick={() => onSort(columnKey)}>
        <HugeiconsIcon
          size={16}
          className={cx(
            "transition-transform text-content-300",
            currentDirection !== defaultDirection ? "rotate-180" : "rotate-0"
          )}
          stroke="1.33px"
          icon={isDueDate ? ArrowUp02Icon : ArrowDown02Icon}
        />
      </button>
    </div>
  );
};
